import Setor from "model/administracao/cadastro/Setor";
import { BaseModel } from "model/BaseModel";
import ClassePlanoAuditoria from "./ClassePlanoAuditoria";
import PlanoAuditoria from "./PlanoAuditoria";
import { BaseEditModel } from "model/BaseEditModel";
import Usuario from "model/administracao/cadastro/Usuario";
import Periodicidade from "model/periodicidade/Periodicidade";

export default class SetorPlanoAuditoria implements BaseEditModel {

    id: number;
    codigo: string | null;
    key: string | null = "";
    sequencial: number | null = 0;
    planoAuditoria: PlanoAuditoria | null;
    auditor: Usuario | null;
    setor: Setor | null;
    periodicidade: Periodicidade | null;
    limite: Periodicidade | null;
    geraAuditoriaApp: boolean | null;

    constructor(
        id = 0,
        codigo = null,
        planoAuditoria = null,
        responsavelAuditoria = null,
        setor = null,
        periodicidade = null,
        limite = null,
        gerarAuditoriaApp = false
    ) {
        this.id = id;
        this.codigo = codigo;
        this.planoAuditoria = planoAuditoria;
        this.auditor = responsavelAuditoria;
        this.setor = setor;
        this.periodicidade = periodicidade;
        this.limite = limite;
        this.geraAuditoriaApp = gerarAuditoriaApp;
    }
}